import React from 'react';
import { motion, useScroll, useSpring } from 'framer-motion';

const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 120, damping: 30, mass: 0.3 });
  return (
    <motion.div
      data-testid="scroll-progress"
      style={{ scaleX }}
      className="fixed top-0 left-0 right-0 h-[4px] origin-left z-[100] bg-gradient-to-r from-[#8a6b2f] via-[#e7d3a1] to-[#c6a15b] shadow-[0_0_12px_rgba(231,211,161,0.6)]"
    />
  );
};

export default ScrollProgress;
